import summary from 'reducers/dashboard/sales/summary';
import { combineReducers } from 'redux';

export default combineReducers({
  summary,
});
